
<template>
  <a-card :bordered="false">
    <component @onEdit="handleEdit" @onGoBack="handleGoBack" :record="record" :is="currentComponet" @onCreate="handleCreate"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/a-role/table/List'
import Edit from '@/views/a-role/table/Edit'
import Create from '@/views/a-role/table/RoleCreate'

export default {
  name: 'ContractInformation',
  components: {
    AInput,
    ATextarea,
    List,
    Edit,
    Create
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  created () {

  },
  methods: {
    handleCreate (record) {
      this.record = record || ''
      this.currentComponet = 'Create'
      console.log(record)
    },
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
